var React = require('react');

function Capital (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.5451 4.56641H10.0203V7.86531H17.7963L10.0203 15.6308L10.7691 16.3744L18.5451 8.60888V16.3744H21.844V7.86531V4.56641H18.5451Z","fill":"#4F555F","key":0}),React.createElement("path",{"d":"M25.3263 11.9336V25.4382H4.67407V11.9336H13.7173L10.0204 15.6305L10.7692 16.374L15.2149 11.9336H18.5452V16.374H21.8441V11.9336H25.3263Z","fill":"#8C95A3","key":1}),React.createElement("path",{"d":"M21.844 4.57031V11.9326H18.5451V8.61279L15.2147 11.9326H13.7171L17.7963 7.85875H10.0203V4.57031H21.844Z","fill":"#C7CED4","key":2})]);
}

Capital.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Capital;

Capital.default = Capital;
